import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from 'src/entities/ActivityLog/Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment;
}

const ActivityLogTaskRescheduleLogDeleted: FCWithFragments<Fragments> = ({ activityLog }) => {
  const { details } = activityLog;

  // eslint-disable-next-line no-underscore-dangle
  if (!details || details.__typename !== 'ActivityLogRescheduleLogDetails') {
    throw new Error('ActivityLogTaskRescheduleLogDeleted: details is not ActivityLogRescheduleLogDetails');
  }

  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.deletedARescheduleLog"
    />
  );
};

ActivityLogTaskRescheduleLogDeleted.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}

    fragment ActivityLogTaskRescheduleLogDeleted_activityLog on ActivityLog {
      id
      details {
        ... on ActivityLogRescheduleLogDetails {
          __typename
          rescheduleLog {
            id
            note
          }
        }
      }
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskRescheduleLogDeleted;
